import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useBulletinResponse } from '../../../context/bulletin';
import JiraTicketList from './ModalContent/JiraTicketList';

interface DailyReportModalProps {
  show: boolean;
  onClose: () => void;
}

function DailyReportModal({ show, onClose }: DailyReportModalProps) {
  const bulletinResponse = useBulletinResponse();

  const tickets = bulletinResponse.bulletin.jira_tickets;
  const hasJiraTickets = tickets.length > 0;

  return (
    <Modal show={show} onHide={onClose} size="lg" centered>
      <Modal.Header>
        <h2>Daily Report</h2>
      </Modal.Header>
      <Modal.Body>
        {hasJiraTickets ? (
          <JiraTicketList tickets={tickets} />
        ) : (
          <p>Bulletin validated without messages</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-primary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default DailyReportModal;
